import { Component, Input, OnInit } from '@angular/core';
import { RepoSettingsService } from '../../../data/repositories/repo-settings.service';
import { RouterStateService } from '../../../core/routing/router-state.service';
import { Router } from '@angular/router';

@Component({
    selector: 'app-sidebar2-option',
    templateUrl: './sidebar2-option.component.html',
    standalone: false,
})
export class Sidebar2OptionComponent {
    // @ts-ignore TS2564
    @Input() heading: string;
    // @ts-ignore TS2564
    @Input() settingsFlag: string;
    // @ts-ignore TS2564
    @Input() defaultRoute: string;
    @Input() defaultQueryParams: any;
    // @ts-ignore TS2564
    @Input() modelName: string;

    constructor(
        private router: Router,
        private repoSettings: RepoSettingsService,
        private routerStateService: RouterStateService
    ) {}

    getHeaderLink() {
        // Just having a default route
        const destRoute = this.defaultRoute || this.routerStateService.getCurrentUrlRoute();
        const params = this.routerStateService.getCurrentUrlQueryParams();

        let paramsToUse =
            this.defaultQueryParams && params?.submenu !== this.defaultQueryParams?.submenu ? this.defaultQueryParams : params;
        let destParams = JSON.parse(JSON.stringify(paramsToUse)) || {}; // Clone so we don't alter the state params here

        // Don't stash any settings if we're on a non-replacement route (routeLess panel)
        if (!this.repoSettings.ShowIntegrationsPanel && !this.repoSettings.ShowExplorePanel && !this.repoSettings.ShowMyProfilePanel) {
            // @ts-ignore TS7052
            this.repoSettings[this.settingsFlag + 'RoutePath'] = destRoute;
            // @ts-ignore TS7052
            this.repoSettings[this.settingsFlag + 'Params'] = JSON.stringify(destParams);
        }

        this.router.navigate([destRoute], { queryParams: destParams, queryParamsHandling: 'replace', onSameUrlNavigation: 'reload' });
    }
}
